module.exports = __webpack_public_path__ + "static/img/10.5b244c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/listen-report/10.png
// module id = XRdQ
// module chunks = 215